import { connect } from 'react-redux';
import Delivery from './Delivery';
import { getFormValues, reset, isDirty, destroy } from 'redux-form';
import { Dispatch, bindActionCreators } from 'redux';
import { actions as uiActions } from 'ducks/ui';
import { IApplicationState } from 'ducks/reducers';
import { selectors as configSelectors } from 'ducks/appConfig';

const FORM_NAME = 'DeliveryDetailsForm';

const mapStateToProps = (state: IApplicationState) => ({
    dirty: isDirty(FORM_NAME)(state),
    formValues: getFormValues(FORM_NAME)(state),
    isV2: configSelectors.isV2(state),
    isV3: configSelectors.isV3(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
    {
        changeConfirmationDialog: uiActions.changeConfirmationDialog,
        resetForm: () => reset(FORM_NAME),
        destoryForm: () => destroy(FORM_NAME),
    },
    dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Delivery);
